import 'bootstrap/dist/css/bootstrap.css';
import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { icons } from './assets/icons'
import { Provider } from 'react-redux'
import store from './store'
import * as SyncfusionBase from '@syncfusion/ej2-base';

// Registering Syncfusion license key
SyncfusionBase.registerLicense('Ngo9BigBOggjHTQxAR8/V1NNaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXxcdXRcQmhdUUd3W0FWYUA=');

React.icons = icons

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

let process = {}

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    rootElement
);

registerServiceWorker();